<template>
    <rkm-overlay>
        <rkm-layout-body title="Regularização de Cadastro">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/regularizacao-cadastro/List'

export default {
    components: { List },
}
</script>